export enum StatusRequisicao {
    AGUARDANDO = 'A',
    ACEITA = 'F',
    ACEITA_PARCIALMENTO = 'P',
    ESTORNO = 'E',
    RECUSADO = 'R'
}
